<template>
  <div
    v-if="getParam('account_custom_type') !== 'yektanet-rubika-adv'"
    class="brand-section-container d-flex flex-column justify-content-center h-100"
  >
    <div class="brand-section-header text-center mb-3 mb-xl-4">
      <div class="brand-section-header-logo mb-1">
        <service-promotion-logo style="height: 120px;" />
      </div>
      <div class="font-5">
        {{ $t("service_promotion_slogan.short") }}
      </div>
      <div
        :class="['w-75 mx-auto', { rtl: $i18n.locale === 'fa' }]"
        style="font-size: 12px; color: #666; margin-top: 10px"
      >
        {{ $t("service_promotion_slogan.long") }}
      </div>
    </div>
    <div class="brand-section-body mx-auto">
      <a
        v-for="srvc in showingServices"
        :key="srvc.name"
        :href="`${srvc.url}/?utm_source=accounts&utm_medium=logo&utm_term=${srvc.name}&utm_campaign=${utmCampaign}`"
        class="brand-icon d-block"
        target="_blank"
        :data-gtm-name="
          utmCampaign === 'login'
            ? 'login_service_links'
            : 'logout_service_link'
        "
        :data-gtm-value-one="srvc.name"
        :data-gtm-value-two="`${srvc.url}/?utm_source=accounts&utm_medium=logo&utm_term=${srvc.name}&utm_campaign=${utmCampaign}`"
        @click="handleServiceClickEvent(srvc.name)"
      >
        <div class="brand-section-body-item">
          <div class="brand-section-body-item_logo">
            <img :src="platformLogos[srvc.name]" :alt="`${srvc.name} logo`" />
          </div>
          <div class="brand-section-body-item_intro">
            <span style="font-weight: 500">
              {{ $t(`${srvc.name}_name`) }}
            </span>
            {{ $t(`${srvc.name}_slogan`) }}
          </div>
        </div>
      </a>
    </div>
  </div>
</template>

<script>
import ServicePromotionLogo from "../../../img/servicePromotionLogo.svg";
import services from "./serviceList.js";
import { getParam } from "~/utils";

export default {
  data: () => ({ platformLogos }),
  components: { ServicePromotionLogo },
  props: {
    utmCampaign: {
      type: String,
      required: true,
    },
    pltService: {
      type: String,
      default: "",
    },
  },
  computed: {
    showingServices() {
      return this.services.filter(({ name }) => name !== this.pltService);
    },
  },
  created() {
    this.services = services("desktop");
  },
  methods: {
    getParam,

    handleServiceClickEvent(serviceName) {
      _paq.push(["trackEvent", "Services", "Service Link Click", serviceName]);
    },
  },
};
</script>

<style></style>
